import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs, Tab, FormControl, InputGroup } from 'react-bootstrap';
import classNames from 'classnames';

import { CTAButtons, PageHeader } from 'components';
import { integrationTypes, levels } from 'pages/Hardware/Integrations/schemas';
import { getAllWarehouses } from 'rdx/warehouses';
import { getPointsOfSale } from 'rdx/pointsOfSale';

import './integration.scss';

function Item({ name, onClick, active = false }) {
  return (
    <div
      className={classNames('card-list-item', { active, pointer: !!onClick })}
      onClick={() => onClick && onClick()}
    >
      {name}
    </div>
  );
}

Item.propTypes = {
  active: PropTypes.bool,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
};

function SelectIntegration({ type, setType }) {
  return (
    <div className="card-list">
      {integrationTypes.map(({ key, name }) => (
        <Item
          key={key}
          active={type === key}
          onClick={() => setType(key)}
          name={name}
        />
      ))}
    </div>
  );
}

function SelectTypeAndLevel() {
  const location = useLocation();
  const navigate = useNavigate();

  const warehouses = useSelector(getAllWarehouses);
  const pointsOfSale = useSelector(getPointsOfSale);

  const [level, setLevel] = useState('Company');
  const [levelId, setLevelId] = useState();
  const [integrationType, setIntegrationType] = useState('');

  // levelId options dictionary
  const scopeIDOptions = {
    // as for the current moment there can only be one company per account
    Company: [],
    Warehouse: warehouses.map(({ warehouseID, name }) => ({
      name,
      value: warehouseID,
    })),
    Pos: pointsOfSale.map(({ name, pointOfSaleID, warehouseName }) => ({
      name,
      warehouseName,
      value: pointOfSaleID,
    })),
  };

  const buttons = {
    next: {
      text: 'Continue',
      disabled: !(level && (level === 'Company' || levelId) && integrationType),
      onClick: () =>
        navigate(
          `${location.pathname}/${level}/${levelId || 0}/${integrationType}`,
        ),
    },
  };

  return (
    <div className="flex-fill d-flex flex-column flex-wrap">
      <PageHeader
        goBack={() => navigate('/hardware')}
        title="Integration Type and Level"
      />
      <Tabs
        id="hardware-integration-scopes"
        activeKey={level}
        onSelect={(k) => {
          if (level !== k) {
            setLevel(k);
            setLevelId(null);
          }
        }}
      >
        {levels.map((lvl) => (
          <Tab key={lvl} eventKey={lvl} title={lvl} className="pt-3" />
        ))}
      </Tabs>
      {level !== 'Company' && (
        <div className="jumbotron">
          <h5>{`Select ${level} id:`}</h5>
          <InputGroup className="my-1">
            <FormControl
              as="select"
              value={levelId || ''}
              onChange={(event) => setLevelId(event.target.value)}
            >
              <option value="">{`No selected ${level}`}</option>
              {!!scopeIDOptions[level].length &&
                scopeIDOptions[level].map((item) => (
                  <option key={item.value} value={item.value}>
                    {`${item.name}${
                      item.warehouseName ? ` - ${item.warehouseName}` : ''
                    }`}
                  </option>
                ))}
            </FormControl>
          </InputGroup>
        </div>
      )}
      <SelectIntegration type={integrationType} setType={setIntegrationType} />
      <CTAButtons buttons={buttons} />
    </div>
  );
}

export default SelectTypeAndLevel;
